import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/claim/rect.png'


const _withScopeId = n => (_pushScopeId("data-v-f4053d2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "claim-wrap wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "rect"
}, null, -1))
const _hoisted_3 = { class: "wrap-title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Payout Round", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Status", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Generate Payout Round")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("RT AFC List Upload")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("RT LC List Upload")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Submit For Checking")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Export Pending Case")
const _hoisted_11 = {
  key: 5,
  style: {"color":"#dcdcdc","cursor":"not-allowed"},
  class: "font_family icon-GeneratePayoutForm"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Generate Payout Form")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("View")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Delete")
const _hoisted_15 = { class: "pagination-container d-f justify-e" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_payout_round_detail = _resolveComponent("payout-round-detail")!
  const _component_upload_detail = _resolveComponent("upload-detail")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumb, { dataSource: [] }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", null, [
        _hoisted_2,
        _createElementVNode("strong", _hoisted_3, _toDisplayString(_ctx.$t("retailClaim.RT")), 1)
      ]),
      _createVNode(_component_a_space, {
        class: "feature-con",
        align: "end"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_space, { size: _ctx.selectSize }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _hoisted_4,
                _createVNode(_component_a_select, {
                  value: _ctx.payoutVal,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.payoutVal) = $event)),
                  placeholder: "Please select",
                  class: "sel-inp-size",
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getTableDateHandle(_ctx.payoutVal, 'afcLcType')))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payoutList, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        value: item.id,
                        key: item.id,
                        title: item.name
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value", "title"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _createElementVNode("div", null, [
                _hoisted_5,
                _createVNode(_component_a_select, {
                  value: _ctx.statusVal,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.statusVal) = $event)),
                  placeholder: "Please select",
                  class: "sel-inp-size",
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getTableDateHandle(_ctx.statusVal, 'status')))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusList, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        value: item.value,
                        key: item.value,
                        title: item.label
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["value", "title"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ])
            ]),
            _: 1
          }, 8, ["size"]),
          _createVNode(_component_a_space, {
            size: 20,
            style: {"text-align":"right"}
          }, {
            default: _withCtx(() => [
              (_ctx.$btnPermissions('FRC0001'))
                ? (_openBlock(), _createBlock(_component_a_tooltip, { key: 0 }, {
                    title: _withCtx(() => [
                      _hoisted_6
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("i", {
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.generateRoundHandle && _ctx.generateRoundHandle(...args))),
                        class: "font_family icon-GeneratePayoutRound1"
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.$btnPermissions('FRC0002'))
                ? (_openBlock(), _createBlock(_component_a_tooltip, { key: 1 }, {
                    title: _withCtx(() => [
                      _hoisted_7
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("i", {
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.uploadHandle('AFC'))),
                        class: "font_family icon-AFCRTListUpload"
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.$btnPermissions('FRC0003'))
                ? (_openBlock(), _createBlock(_component_a_tooltip, { key: 2 }, {
                    title: _withCtx(() => [
                      _hoisted_8
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("i", {
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.uploadHandle('LC'))),
                        class: "font_family icon-LCRTListUpload"
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.$btnPermissions('FRC0004'))
                ? (_openBlock(), _createBlock(_component_a_tooltip, { key: 3 }, {
                    title: _withCtx(() => [
                      _hoisted_9
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("i", {
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.submitCheckingHandle && _ctx.submitCheckingHandle(...args))),
                        class: "font_family icon-tijiao"
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.$btnPermissions('FRC0005'))
                ? (_openBlock(), _createBlock(_component_a_tooltip, { key: 4 }, {
                    title: _withCtx(() => [
                      _hoisted_10
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("i", {
                        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.exportFailResultHandle && _ctx.exportFailResultHandle(...args))),
                        class: "font_family icon-Exportpendingcase"
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!_ctx.isActive)
                ? (_openBlock(), _createElementBlock("i", _hoisted_11))
                : _createCommentVNode("", true),
              (_ctx.isActive && _ctx.$btnPermissions('FRC0006'))
                ? (_openBlock(), _createBlock(_component_a_tooltip, {
                    key: 6,
                    placement: "topRight"
                  }, {
                    title: _withCtx(() => [
                      _hoisted_12
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("i", {
                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.payoutFromHandle && _ctx.payoutFromHandle(...args))),
                        class: "font_family icon-GeneratePayoutForm"
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_table, {
        class: "ant-table-striped",
        rowKey: "id",
        "row-selection": {
        selectedRowKeys: _ctx.selectedRowKeys,
        onChange: _ctx.onSelectChange,
      },
        columns: _ctx.columns,
        "data-source": _ctx.claimListData,
        pagination: false,
        scroll: { y: _ctx.tableHeight },
        rowClassName: 
        (record, index) => (index % 2 === 1 ? 'table-striped' : null)
      
      }, {
        round: _withCtx(({ text }) => [
          _createElementVNode("span", null, _toDisplayString(text), 1)
        ]),
        operation: _withCtx(({ record }) => [
          (_ctx.$btnPermissions('FRC0007'))
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                type: "link",
                onClick: ($event: any) => (_ctx.viewHandle(record.id))
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.claimListData.length)
            ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                key: 1,
                "ok-text": "Confirm",
                onConfirm: ($event: any) => (_ctx.deleteHandle(record.id))
              }, {
                title: _withCtx(() => [
                  _createTextVNode("Confirm to delete payout round：" + _toDisplayString(record.name) + "?", 1)
                ]),
                default: _withCtx(() => [
                  (
              record.statusLabel === 'Activated' && _ctx.$btnPermissions('FRC0008')
            )
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        type: "link"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_14
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["onConfirm"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["row-selection", "columns", "data-source", "scroll", "rowClassName"]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_a_pagination, {
          total: _ctx.paginationObj.total,
          "show-size-changer": "",
          "show-total": (total) => `共 ${_ctx.paginationObj.total} 条`,
          onChange: _cache[10] || (_cache[10] = 
          (page, pageSize) =>
            _ctx.pageChange(page, pageSize, _ctx.claimListParams, _ctx.getTableData)
        ),
          onShowSizeChange: _cache[11] || (_cache[11] = 
          (page, pageSize) =>
            _ctx.sizeChange(page, pageSize, _ctx.claimListParams, _ctx.getTableData)
        ),
          pageSize: _ctx.paginationObj.size,
          "onUpdate:pageSize": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.paginationObj.size) = $event)),
          current: _ctx.paginationObj.current,
          "onUpdate:current": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.paginationObj.current) = $event)),
          pageSizeOptions: ['10', '20', '30', '40', '50']
        }, {
          buildOptionText: _withCtx((props) => [
            _createElementVNode("span", null, _toDisplayString(props.value) + "条/页", 1)
          ]),
          _: 1
        }, 8, ["total", "show-total", "pageSize", "current"])
      ])
    ]),
    (_ctx.isVisible)
      ? (_openBlock(), _createBlock(_component_payout_round_detail, {
          key: 0,
          isVisible: _ctx.isVisible,
          onCloseSubVisible: _ctx.closeSub
        }, null, 8, ["isVisible", "onCloseSubVisible"]))
      : _createCommentVNode("", true),
    (_ctx.isUploadVisible)
      ? (_openBlock(), _createBlock(_component_upload_detail, {
          key: 1,
          onChangeTable: _ctx.refreshTable,
          isUploadVisible: _ctx.isUploadVisible,
          curRole: _ctx.curRole,
          onCloseUploadVisible: _ctx.closeUpload
        }, null, 8, ["onChangeTable", "isUploadVisible", "curRole", "onCloseUploadVisible"]))
      : _createCommentVNode("", true)
  ], 64))
}